import Typography from '@mui/material/Typography';
import Grid from '@mui/material/GridLegacy';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import CardContent from '@mui/material/CardContent';
import { capitalizeFirstLetter } from '../../../config/helpers';


const ListAddresses = ({ type, address }) => {
    return (
        <Grid item xs={3} md={3}>
            <Card style={{}}>
                <CardHeader sx={{
                    '&. MuiTypography-root': {
                        fontWeight: '800'
                    }
                }} subheader={capitalizeFirstLetter(type)} />
                <Divider />
                <CardContent>
                    <div>
                        <Typography
                            variant="subtitle1"
                            component="div"
                            gutterBottom={true}
                        >
                            {/* {capitalizeFirstLetter(
                            addressType
                        )}{" "}
                        address */}
                        </Typography>
                    </div>
                    {/* <Divider
                        style={{
                            marginBottom: "5px",
                        }}
                    /> */}
                    <div
                        style={{
                            textAlign: "left",
                        }}
                    >
                        <Typography
                            sx={{
                                fontWeight:
                                    "bold",
                            }}
                            variant="body1"
                            gutterBottom={false}
                        >
                            {
                                address.CompanyName
                            }
                        </Typography>

                        <Typography
                            variant="body1"
                            gutterBottom={false}
                        >
                            {
                                address.ContactName
                            }
                        </Typography>

                        <Typography
                            variant="body1"
                            gutterBottom={false}
                        >
                            {
                                address.Address1
                            }
                        </Typography>

                        <Typography
                            variant="body1"
                            gutterBottom={false}
                        >
                            {
                                address.Address2
                            }
                        </Typography>

                        <Typography
                            variant="body1"
                            gutterBottom={false}
                        >
                            {
                                address.Town
                            }
                        </Typography>

                        <Typography
                            variant="body1"
                            gutterBottom={false}
                        >
                            {
                                address.County
                            }
                        </Typography>


                        <Typography
                            variant="body1"
                            gutterBottom={false}
                        >
                            {
                                address.PostCode
                            }
                        </Typography>
                    </div>
                </CardContent>
            </Card>
        </Grid>
    )
}

export default ListAddresses